<template>
  <div>
    <transition
      enter-active-class="ease-in-out duration-300"
      enter-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="ease-in-out duration-300"
      leave-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        role="button"
        class="bg-ontick-carbon-900 pointer-events-none fixed inset-0 z-30 bg-opacity-75"
        v-if="active"
      >
        <button
          class="pointer-events-auto absolute inset-0"
          style="z-index: -1"
          @click.self="$emit('close')"
        >
          <span class="sr-only"> Fechar </span>
        </button>
        <transition
          appear
          enter-active-class="transform ease-out duration-300"
          enter-class="opacity-0 translate-y-full"
          enter-to-class="opacity-100 translate-y-0"
          leave-active-class=" transform ease-out duration-300"
          leave-class="opacity-100 translate-y-0"
          leave-to-class="opacity-0 translate-y-full"
        >
          <div
            class="bg-ontick-graphite-500 pointer-events-auto absolute bottom-0 h-4/5 w-full overflow-hidden rounded-t-[32px]"
          >
            <div class="flex h-full flex-col gap-6 px-4 py-10">
              <div class="flex flex-col gap-4">
                <p class="text-2xl font-bold">Resumo</p>
              </div>
              <div class="text-shadow flex flex-col gap-3 text-sm">
                <dl>
                  <dt>ID:</dt>
                  <dd>
                    {{ data.bo_id }}
                  </dd>
                </dl>
                <dl>
                  <dt>Ativo:</dt>
                  <dd>
                    {{ data.bo_symbol }}
                  </dd>
                </dl>
                <dl>
                  <dt>Status:</dt>
                  <dd>
                    {{ data.bo_status }}
                  </dd>
                </dl>
                <dl>
                  <dt>Best:</dt>
                  <dd>
                    <div
                      class="flex items-center rounded-full pr-2 text-gray-50"
                      :class="
                        data.bo_direction == 'BUY'
                          ? 'bg-ontick-green-600'
                          : 'bg-ontick-orange-600'
                      "
                    >
                      <i
                        v-if="data.bo_direction == 'BUY'"
                        v-html="$icons.trend_up"
                      ></i>
                      <i
                        v-else-if="data.bo_direction == 'SELL'"
                        v-html="$icons.trend_down"
                      ></i>
                      <span class="direction-shadow text-[10px] uppercase">
                        {{ data.bo_direction == "BUY" ? "Sobe" : "Desce" }}
                      </span>
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dt>Entrada:</dt>
                  <dd class="flex flex-col items-end gap-2">
                    <span>
                      {{ formatDate(data.bo_entry_datetime) }}
                    </span>
                    <span class="text-gray-500">
                      ({{ data.bo_entry_price }})
                    </span>
                  </dd>
                </dl>
                <dl>
                  <dt>Saída:</dt>
                  <dd class="flex flex-col items-end gap-2">
                    <span>
                      {{ formatDate(data.bo_exit_datetime) }}
                    </span>
                    <span class="text-gray-500">
                      ({{ data.bo_exit_price }})
                    </span>
                  </dd>
                </dl>
                <dl>
                  <dt>Multiplicador:</dt>
                  <dd>{{ data.bo_multiplier }}x</dd>
                </dl>
                <dl>
                  <dt>Resultado:</dt>
                  <dd class="flex items-center gap-2">
                    <i v-if="data.bo_profit > 0" v-html="$icons.play_green"></i>
                    <i
                      v-else-if="data.bo_profit < 0"
                      v-html="$icons.play_red"
                    ></i>
                    <i v-else class="h-3 w-3 rounded-full bg-gray-500"></i>
                    <span>
                      {{ data.bo_profit | currency }}
                    </span>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
    },
    data: {
      type: Object,
    },
  },

  computed: {
    pnl() {
      return 5555;
    },
  },

  methods: {
    formatDate(date) {
      return this.moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },

  watch: {
    active: {
      handler(val) {
        const chat_button = document.getElementById("fc_frame");
        if (val) {
          chat_button.classList.add("hidden");
        } else {
          chat_button.classList.remove("hidden");
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.gradient {
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #202a37 69.82%);
}
.btn-shadow {
  box-shadow: 0px 4px 4px 1px rgba(0, 0, 0, 0.35);
}
.param-box {
  @apply bg-ontick-carbon-500 flex flex-col gap-2 rounded-2xl p-3;
}
.text-shadow {
  text-shadow: 0px 2px 1px rgba(0, 0, 0, 0.5);
  &-lg {
    text-shadow: 0px 3px 2px rgba(0, 0, 0, 0.5);
  }
}
.call-btn {
  @apply flex w-full items-center justify-center gap-2 rounded-xl py-3 filter active:brightness-75;
}
dl {
  @apply flex items-start justify-between gap-2;
}
</style>
